import { useEffect } from 'react';
import { Calendar } from 'src/Components';
import { DataPickerPlaceHolder } from './DatePickerPlaceholder';

interface DatePickerProps {
	/** CSS-класс корневого элемента календаря */
	className?: string;
	isPlaceHolder?: boolean;
	value: Date | null | [Date, Date];
	setValue: (value: any) => void;
	onClear?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	onClose?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	headless?: boolean;
	isBetween?: boolean;
	withTime?: boolean;
	disabled?: boolean;

	minDate?: Date;
	maxDate?: Date;
}

const DataPicker: React.FC<DatePickerProps> = (props) => {
	const {
		value,
		setValue,
		onClear,
		onClose,
		isBetween = false,
		isPlaceHolder = false,
		...otherProps
	} = props;

	useEffect(() => {
		if (Array.isArray(value)) {
			const val = [];
			val[0] = parseDate(value[0]);
			val[1] = parseDate(value[1]);
			setValue(val);
		} else {
			setValue(parseDate(value));
		}
		// eslint-disable-next-line
	}, []);

	if (isPlaceHolder) {
		return (
			<DataPickerPlaceHolder
				isBetween={isBetween}
				value={value}
				onClear={onClear}
			/>
		);
	}

	return (
		<Calendar
			{...otherProps}
			style={{ position: 'unset' }}
			type={isBetween ? 'between' : 'once'}
			values={Array.isArray(value) ? value : [value]}
			onChangeValues={(v) => {
				return isBetween ? setValue(v) : setValue(v[0]);
			}}
		/>
	);
};

/** Парсит дату из строки  */
const parseDate = (value: any) => {
	if (!value) {
		return null;
	}
	const date = new Date(Date.parse(value));
	date.setHours(0);
	return date;
};

export default DataPicker;
